import { services } from '@ambita/ambita-components-core';

services.i18n.registerTranslations('propertyLookup', {
  nb: {
    summary: 'Oppsummering',
    addressUpdated: 'Oppdatert',
    showInMap: 'Vis i kart',
    unprovided: 'IKKE OPPGITT',
    indexSections: 'Seksjonssameie med adresser',
    indexOwners: 'Eiere',
    indexConveyance: 'Siste omsetning',
    indexCadastreInfo: 'Matrikkelopplysninger',
    indexUnregisteredOwnerships: 'Ikke tinglyst eierforhold',
    indexCultureHeritage: 'Kulturminner på matrikkelen',
    indexSoilContamination: 'Grunnforurensing',
    indexComplaints: 'Klage på vedtak i Matrikkelen',
    indexAffairs: 'Forretninger',
    indexAddresses: 'Matrikkelens adresser',
    indexBuildings: 'Bolig- og bygningsopplysninger',
    coordSystem: 'Koord.sys.nr',
    coordX: 'Koordinat X',
    coordY: 'Koordinat Y',
    cadastre: 'Matrikkel',
    titleOwners: 'Eiere',
    ownerId: 'ID',
    ownerDate: 'Født',
    ownerName: 'Navn',
    ownerFraction: 'Andel',
    ownerAddress: 'Adresse',
    ownerPostalAddress: 'Postadresse',
    ownerRole: 'Rolle',
    titleConveyance: 'Siste omsetning',
    conveyanceDate: 'Tinglyst dato',
    conveyancePrice: 'Kjøpesum',
    conveyanceType: 'Omsetningstype',
    conveyanceDocumentCode: 'Dokumenttype',
    conveyanceEntireProperty: 'Gjelder hele eiendommen',
    conveyanceMultipleCadastres: 'Gjelder flere eiendommer',
    titleCadastreInfo: 'Matrikkelopplysninger',
    cadastreType: 'Type',
    cadastreUnitName: 'Bruksnavn',
    cadastreEstablishedDate: 'Etableringsdato',
    cadastreArea: 'Areal',
    cadastreKVM: 'm²',
    cadastreAreaSource: 'Arealkilde',
    cadastreAreaNote: 'Arealmerknad',
    cadastreRegistered: 'Tinglyst',
    cadastreTechnicalRegistered: 'Matrikkelført',
    cadastreLeasedLand: 'Har festegrunn',
    cadastreLandTaxation: 'Skyld',
    cadastreGroup: 'Næringsgruppe',
    cadastreFarm: 'Landbruk',
    cadastrePlots: 'Antall teiger',
    cadastreSectioned: 'Seksjonert',
    cadastrePurpose: 'Formål',
    cadastreFraction: 'Sameiebrøk',
    cadastreCoordinates: 'Eiendomskoordinater',
    cadastreUnregisteredOwnership: 'Ikke tinglyst eierforhold',
    unregisteredOwnershipInfo: 'Ingen ikke tinglyste eierforhold registrert på matrikkelenheten.',
    unregisteredOwnershipRole: 'Rolle',
    unregisteredOwnershipId: 'Fødsels-/Org.nr',
    unregisteredOwnershipOwner: 'Eier',
    unregisteredOwnershipType: 'Type',
    cadastreHeritage: 'Kulturminner',
    heritageInfo: 'Ingen kulturminner registrert på matrikkelenheten.',
    heritageText: 'I matrikkelen fremgår kun informasjon om fredet kulturminne der det er registrert i' +
      ' Riksantikvarens arkiv på eiendom og bygning. Kulturminner som ikke er registrert i Matrikkelen kan dermed ' +
      ' allikevel forekomme på eiendommen. Merk at disse opplysningene ikke omfatter informasjon om eventuell ' +
      ' verning / verneklasse for eiendom eller bygningsmasse.',
    heritageLocalityNumber: 'Lokalitetsnr',
    heritageType: 'Art',
    heritagePreservationType: 'Vernetype',
    heritageCategory: 'Kategori',
    heritageRegistered: 'Matrikkelført',
    heritageUpdated: 'Oppdatert',
    cadastreSoilContaminations: 'Grunnforurensing',
    soilContaminationsInfo: 'Ingen grunnforurensing registrert på matrikkelenheten.',
    soilContaminationText: 'I matrikkelen fremgår kun informasjon om grunnforurensning som eventuelt er registrert' +
      ' på eiendommen i forurensningsmyndighetenes arkiver. Grunnforurensning som ikke er registrert kan dermed' +
      ' allikevel forekomme på eiendommen.',
    soilContaminationLocalityNumber: 'Lokalitetsnr',
    soilContaminationLinkText: 'Gå til miljødirektoratets nettsider',
    soilContaminationRegisteredDate: 'Matrikkelført',
    soilContaminationLastUpdatedDate: 'Oppdatert',
    soilContaminationAuthority: 'Myndighet',
    soilContaminationLocalityName: 'Navn',
    soilContaminationDegreeOfImpact: 'Påvirkningsgrad',
    cadastreComplaints: 'Klage på vedtak i Matrikkelen',
    complaintsInfo: 'Ingen klage registrert på matrikkelenheten.',
    complaintRegisteredDate: 'Dato',
    complaintConcerns: 'Klage gjelder',
    complaintCadastre: 'Matrikkel',
    cadastreAffairs: 'Forretninger',
    affairsInfo: 'Ingen forretninger registrert på matrikkelenheten.',
    affairsType: 'Type',
    affairsDate: 'Dato',
    affairsDocumentDate: 'Forretning',
    affairsRegistryDate: 'Matrikkelført',
    affairsRole: 'Rolle',
    affairsCadastre: 'Matrikkel',
    affairsArea: 'Arealendring',
    titleAddresses: 'Matrikkelens adresser',
    titleNoAddresses: 'Ingen adresse registrert',
    districtMunicipality: 'Kommune',
    districtBorough: 'Bydel',
    districtStatisticalUnit: 'Grunnkrets',
    districtElectoralDistrict: 'Valgkrets',
    districtParish: 'Kirkesogn',
    districtUrbanArea: 'Tettsted',
    addressStreetName: 'Veiadresse',
    titleBuildings: 'Bolig- og bygningsopplysninger',
    building: 'Bygning',
    buildingOf: 'av',
    buildingTitleUnits: 'Opplysninger om boliger/bruksenheter',
    unitAddress: 'Adresse',
    unitAddresses: 'Adresser',
    unitNo: 'Nr',
    unitType: 'Type',
    unitBRA: 'BRA',
    unitKitchen: 'Kjøkkenkode',
    unitNoOfRooms: 'Antall rom',
    unitNumberOfBathRooms: 'Bad',
    unitNumberOfWCs: 'WC',
    buildingInfo: 'Ingen bygningsinformasjon registrert på matrikkelenheten',
    buildingTitleInfo: 'Bygningsopplysninger',
    buildingSource: 'Kilde',
    buildingIndustryGroup: 'Næringsgruppe',
    buildingStatus: 'Bygningsstatus',
    buildingEnergySourceType: 'Energikilde',
    buildingHeatingType: 'Oppvarming',
    buildingDischargeType: 'Avløp',
    buildingWaterSupplyType: 'Vannforsyning',
    buildingNumber: 'Bygningsnummer',
    buildingBuiltUpArea: 'Bebygd areal',
    buildingPrimarySpace: 'BRA bolig',
    buildingSecondarySpace: 'BRA annet',
    buildingTotalFloorSpace: 'BRA totalt',
    buildingHasElevator: 'Har heis',
    buildingApprovedDate: 'Rammetillatelse',
    buildingStartedDate: 'Igangset.till',
    buildingCertificateOfCompletion: 'Ferdigattest',
    buildingProvisionalPermission: 'Midl.brukstill.',
    buildingApprovedUsedFrom: 'Tatt i bruk (GAB)',
    buildingNumberOfUnits: 'Antall boliger',
    buildingNumberOfFloors: 'Antall etasjer',
    buildingTitleFloors: 'Etasjeopplysninger',
    floorInfo: 'Ingen etasjeopplysninger registrert på bygningen.',
    floorNo: 'Nr',
    floorNoOfUnits: 'Ant. boliger',
    floorBRA: 'BRA',
    floorUnit: 'Bolig',
    floorOther: 'Annet',
    floorTotal: 'Totalt',
    floorBTA: 'BTA',
    buildingTitleHeritages: 'Kulturminner',
    heritagesInfo: 'Ingen kulturminner registrert på bygningen.',
    heritagesTitle: 'Enkeltminne',
    culturalHeritagesSefrak: 'Sefrakminne',
    sefrakIdent: 'Id',
    sefrakObjectName: 'Objektnavn',
    sefrakSiteDating: 'Tidfesting',
    sefrakOriginalFunction: 'Tidligere funksjon',
    sefrakCurrentFunction: 'Nåværende funksjon',
    sefrakExtension: 'Tilbygg/ombygning',
    goToHeritagesInfoPage: 'Gå til kulturminnesøk sine sider',
    buildingTitleCoordinates: 'Bygningskoodinater',
    loading: 'Laster eiendomsoppslag..',
    waterPlots: 'Vannteig(er)',
    ownerlessPlots: 'Eierløs(e) teig(er)',
    historicCadastre: 'Denne matrikkelenheten er historisk',
    sectionedCadastre: 'Denne matrikkelenheten er seksjonert',
    responsibilityTitle: 'Om fullstendighet og nøyaktighet i matrikkelutskriften:',
    responsibility: `Ambita tar forbehold om at informasjon som hentes fra Matrikkelen kan avvike fra de faktiske
     forhold, og at grensepunkter mv. kan mangle helt eller delvis eller være feil registrert i Matrikkelen.
     Ambitas Matrikkelutskrift viser arealet som er en geometrisk
    beregning basert på eiendommens grenselinjer. I de tilfeller grensene er markert som fiktive brukes i stedet
    oppgitt areal hvis dette finnes i Matrikkelen.
    Ambita er ikke ansvarlig for tap som oppstår som følge av feil i Matrikkelutskriften.`
  },
  'en-us': {
    summary: 'Summary',
    addressUpdated: 'Updated',
    showInMap: 'Show in map',
    unprovided: 'NOT PROVIDED',
    indexSections: 'Sections with addresses',
    indexOwners: 'Owners',
    indexConveyance: 'Last transaction',
    indexCadastreInfo: 'Cadastre information',
    indexUnregisteredOwnerships: 'Not registered ownership',
    indexCultureHeritage: 'Culture heritages',
    indexSoilContamination: 'Soil contamination',
    indexComplaints: 'Complaints',
    indexAffairs: 'Affairs',
    indexAddresses: 'Addresses',
    indexBuildings: 'Building information',
    coordSystem: 'Coord.sys.no',
    coordX: 'Coord.x',
    coordY: 'Coord.y',
    cadastre: 'Cadastre',
    titleOwners: 'Overview owners',
    ownerId: 'ID',
    ownerDate: 'Born',
    ownerName: 'Name',
    ownerFraction: 'Share',
    ownerAddress: 'Address',
    ownerPostalAddress: 'Postal address',
    ownerRole: 'Role',
    titleConveyance: 'Last conveyance',
    conveyanceDate: 'Registered date',
    conveyancePrice: 'Purchase price',
    conveyanceType: 'Conveyance type',
    conveyanceDocumentCode: 'Document type',
    conveyanceEntireProperty: 'Apply to the entire property',
    conveyanceMultipleCadastres: 'Multiple cadastres',
    titleCadastreInfo: 'Cadastre details',
    cadastreType: 'Type',
    cadastreUnitName: 'Unit name',
    cadastreEstablishedDate: 'Established date',
    cadastreArea: 'Area',
    cadastreKVM: 'm²',
    cadastreAreaSource: 'Area source',
    cadastreAreaNote: 'Area note',
    cadastreRegistered: 'Registered',
    cadastreTechnicalRegistered: 'Technical registered',
    cadastreLeasedLand: 'Has leased land',
    cadastreLandTaxation: 'Land taxation',
    cadastreGroup: 'Industry group',
    cadastreFarm: 'Farm',
    cadastrePlots: 'Number of plots',
    cadastreSectioned: 'Sectioned',
    cadastrePurpose: 'Purpose',
    cadastreFraction: 'Ownership fraction',
    cadastreCoordinates: 'Coordinates',
    cadastreUnregisteredOwnership: 'Unregistered ownership',
    unregisteredOwnershipInfo: 'No unregistered ownerships found on the cadastre.',
    unregisteredOwnershipRole: 'Role',
    unregisteredOwnershipId: 'Id',
    unregisteredOwnershipOwner: 'Owner',
    unregisteredOwnershipType: 'Type',
    cadastreHeritage: 'Cultural heritages',
    heritageInfo: 'No cultural heritages registered on the cadastre.',
    heritageText: 'In Cadastre is stated only information on  protected monument where it is registered in' +
      ' the Cultural Heritage Archives on property and building. Cultural heritage that is not registered in the ' +
      ' cadastre can thus occur on the property. Note that this information does not include information about ' +
      ' any verning / protective class of property or buildings.',
    heritageLocalityNumber: 'Locality no',
    heritageType: 'Type',
    heritagePreservationType: 'Preservation type',
    heritageCategory: 'Category',
    heritageRegistered: 'Registered',
    heritageUpdated: 'Updated',
    cadastreSoilContaminations: 'Soil contaminations',
    soilContaminationsInfo: 'No soil contaminations registered on the cadastre.',
    soilContaminationText: 'In Cadastre is stated only information on soil contamination which may be registered' +
      ' on the property in pollution government archives. Soil contamination that is not registered can thus ' +
      ' occur on the property.',
    soilContaminationLocalityNumber: 'Locality no',
    soilContaminationLinkText: 'View contamination',
    soilContaminationRegisteredDate: 'Registered',
    soilContaminationLastUpdatedDate: 'Updated',
    soilContaminationAuthority: 'Authority',
    soilContaminationLocalityName: 'Name',
    soilContaminationDegreeOfImpact: 'Degree of impact',
    cadastreComplaints: 'Complaints on decisions',
    complaintsInfo: 'No complaints on decisions registered on the cadastre.',
    complaintRegisteredDate: 'Date',
    complaintConcerns: 'Complaint concerns',
    complaintCadastre: 'Cadastre',
    cadastreAffairs: 'Affairs',
    affairsInfo: 'No affairs registered on the cadastre.',
    affairsType: 'Type',
    affairsDate: 'Date',
    affairsDocumentDate: 'Document',
    affairsRegistryDate: 'Registered',
    affairsRole: 'Role',
    affairsCadastre: 'Cadastre',
    affairsArea: 'Area change',
    titleAddresses: 'Cadastre addresses',
    titleNoAddresses: 'No registered addresses.',
    districtMunicipality: 'Municipality',
    districtBorough: 'Borough',
    districtStatisticalUnit: 'Statistical unit',
    districtElectoralDistrict: 'Electoral district',
    districtParish: 'Parish',
    districtUrbanArea: 'Urban area',
    addressStreetName: 'Street name',
    titleBuildings: 'Cadastral housing- and unit details',
    building: 'Building',
    buildingOf: 'of',
    buildingTitleUnits: 'Details on housing/units',
    unitAddress: 'Address',
    unitAddresses: 'Addresses',
    unitNo: 'No',
    unitType: 'Type',
    unitBRA: 'BRA',
    unitKitchen: 'Kitchen code',
    unitNoOfRooms: 'Rooms',
    unitNumberOfBathRooms: 'Bathrooms',
    unitNumberOfWCs: 'WCs',
    buildingInfo: 'No building info registered',
    buildingTitleInfo: 'Building details',
    buildingSource: 'Source',
    buildingIndustryGroup: 'Industry group',
    buildingStatus: 'Status',
    buildingEnergySourceType: 'Energy source',
    buildingHeatingType: 'Heating',
    buildingDischargeType: 'Discharge',
    buildingWaterSupplyType: 'Water supply',
    buildingNumber: 'Unit number',
    buildingBuiltUpArea: 'Built up area',
    buildingPrimarySpace: 'Primary space',
    buildingSecondarySpace: 'Secondary space',
    buildingTotalFloorSpace: 'Total floor space',
    buildingHasElevator: 'Has elevator',
    buildingApprovedDate: 'Approved',
    buildingStartedDate: 'Started',
    buildingCertificateOfCompletion: 'Completion',
    buildingProvisionalPermission: 'Provisional.perm.',
    buildingApprovedUsedFrom: 'Used from (GAB)',
    buildingNumberOfUnits: 'Number of units',
    buildingNumberOfFloors: 'Number of floors',
    buildingTitleFloors: 'Floor details',
    floorInfo: 'No floor details registered for the unit.',
    floorNo: 'No',
    floorNoOfUnits: 'No of units',
    floorBRA: 'BRA',
    floorUnit: 'Unit',
    floorOther: 'Other',
    floorTotal: 'Total',
    floorBTA: 'BTA',
    buildingTitleHeritages: 'Cultural heritages',
    heritagesInfo: 'No cultural heritages registered for the unit.',
    heritagesTitle: 'Single heritages',
    culturalHeritagesSefrak: 'Sefrak heritages',
    sefrakIdent: 'Id',
    sefrakObjectName: 'Object name',
    sefrakSiteDating: 'Site dating',
    sefrakOriginalFunction: 'Original function',
    sefrakCurrentFunction: 'Current function',
    sefrakExtension: 'Extension',
    goToHeritagesInfoPage: 'Go to kulturminnesøks website',
    buildingTitleCoordinates: 'Unit coordinates',
    loading: 'Loading property lookup..',
    waterPlots: 'Water plot(s)',
    ownerlessPlots: 'Ownerless plot(s)',
    historicCadastre: 'This cadastre unit is historic',
    sectionedCadastre: 'This cadastre unit is sectioned',
    responsibilityTitle: 'About the completeness and accuracy of the cadastral statement:',
    responsibility: `Ambita reserves the information obtained from the Cadastre may differ from the actual
     circumstances, and the boundary points may be missing entirely or partially or be incorrectly registered
     in the Cadastre. Ambitas cadastral statement shows the area as a geometric calculation based on the
     property’s boundary lines. In those cases where the boundaries are marked as fictional, the given area is used
     – assuming this is available information in the Cadastre.
     Ambita is not liable for losses arising from errors in the cadastral statement.`
  }
});
